// 菜单的树结构 -- 侧边菜单
// 后续新增菜单的话 需要在这里做新增
export const menuList = [
  // ====================== 创意空间 ======================
  {
    ownId: 21,
    name: "创意空间",
    icon: "el-icon-setting",
    route_path: "/creative-space",
    code: "admin.space",                    // 正确
  },
  {
    ownId: 22,
    name: "作品统计",
    icon: "el-icon-date",
    route_path: "/creative-space/work-stats",
    code: "admin.space.workstatic",         // 正确
  },
  // {
  //   ownId: 23,
  //   name: "签到统计",
  //   icon: "el-icon-edit-outline",
  //   route_path: "/creative-space/checkin-stats",
  //   code: "admin.space.checkinstatic",       // 正确
  // },
  {
    ownId: 26,
    name: "作品管理",
    icon: "el-icon-document-copy",
    route_path: "/creative-space/work-manage",
    code: "admin.space.workmanage",          // 正确
  },
  {
    ownId: 25,
    name: "空间资源",
    icon: "el-icon-truck",
    route_path: "/creative-space/resource-manage",
    code: "admin.space.resourcemanage",      // 正确
  },
  // {
  //   ownId: 28,
  //   name: "儿童档案",
  //   icon: "el-icon-s-management",
  //   route_path: "/creative-space/child-file",
  //   code: "admin.space.childfile",           // 已恢复 + 正确
  // },

  // ====================== 信息管理 ======================
  {
    ownId: 29,
    name: "信息管理",
    icon: "el-icon-phone-outline",
    route_path: "/info-management",
    code: "admin.info",                      // 正确
  },
  {
    ownId: 30,
    name: "儿童管理",
    icon: "el-icon-user",
    route_path: "/info-management/child",
    code: "admin.child.manage",              // 注意：后端是这个，不是 admin.info.childmanage
  },
  {
    ownId: 31,
    name: "毕业儿童",
    icon: "el-icon-school",
    route_path: "/info-management/graduate",
    code: "admin.child.graduate",            // 注意：后端是这个
  },
  {
    ownId: 8,
    name: "班级管理",
    icon: "el-icon-document-copy",
    route_path: "/info-management/class",
    code: "admin.class.manage",              // 注意：后端是这个
  },
  // 添加职工管理
  {
    ownId: 9,
    name: "职工管理",
    icon: "el-icon-s-custom",
    route_path: "/info-management/teacher",
    code: "admin.teacher.manage",              // 注意：后端是这个
  },

  // ====================== 系统配置 ======================
  {
    ownId: 1,
    name: "系统配置",
    icon: "el-icon-office-building",
    route_path: "/system-config",
    code: "admin.sysconfig",                 // 注意：后端是 admin.sysconfig，不是 admin.system
  },
  {
    ownId: 2,
    name: "年级管理",
    icon: "el-icon-document",
    route_path: "/system-config/grade",
    code: "admin.grade.manage",              // 注意：后端是这个
  },
  {
    ownId: 32,
    name: "IC卡管理",
    icon: "el-icon-star-off",
    route_path: "/system-config/iccard",
    code: "admin.child.iccard",              // 正确
  },
  {
    ownId: 24,
    name: "空间配置",
    icon: "el-icon-s-operation",
    route_path: "/system-config/space",
    code: "admin.space.spacemanage",         // 正确
  },
  {
    ownId: 27,
    name: "领域配置",
    icon: "el-icon-document-checked",
    route_path: "/system-config/field",
    code: "admin.space.fieldmanage",         // 正确
  },

  // ====================== 权限管理 ======================
  {
    ownId: 33,
    name: "权限管理",
    icon: "el-icon-key",
    route_path: "/permission",
    code: "admin.permission",                // 正确
  },
  {
    ownId: 34,
    name: "角色管理",
    icon: "el-icon-s-custom",
    route_path: "/permission/role",
    code: "admin.permission.role",           // 正确
  },

  // ====================== 设置 ======================
  {
    id: 50,
    name: "设置",
    route_path: "/system",
    icon: "el-icon-setting",
    code: "admin.set",                       // 正确
  },
  {
    id: 51,
    name: "个人信息",
    icon: "el-icon-user",
    route_path: "/system/personal",
    code: "admin.set.personalInfo",          // 正确
  },
  {
    id: 52,
    name: "版本管理",
    icon: "el-icon-info",
    route_path: "/system/version",
    code: "admin.version",                   // 正确
  },
];